export enum types {
  SET_STATE = "SET_STATE"
}

export enum MoneyType {
  CASH = "CASH",
  COINS = "COINS"
}
